// contexts/onboarding/index.js

import { defineAsyncComponent } from 'vue';

/**
 * Published interface of the Clinic Onboarding context. Everything outside imports from here and
 * nothing deeper — the layers behind it are internal.
 *
 * Named from the domain discovery map, where Clinic Onboarding is a Supporting context owning
 * "clinic provisioning, bulk import, source-system mapping". Every live adapter under
 * `sourceAdapters/` reads a generic spreadsheet; the commented-out ones name competitors outright
 * and are the shape a vendor-specific reader takes when one is revived.
 *
 * @context Getting a clinic's world out of whatever system they were on and into ours: bulk import,
 *   source-system mapping, clinic provisioning
 */

// The dialog is the whole delivery mechanism. A host page opens it for one root entity type and
// gets a completed import back; the pipeline behind it — datasets, field bindings, the intermediate
// representation, normalization, validation — is internal and has no other published entry point.
//
// ASYNC, AND THAT IS PART OF THE CONTRACT. Behind this component sit the pipeline, `xlsx` and
// `jszip`. A static re-export would put all of it in the graph of every page that imports
// `IMPORT_TYPES` from here — four of them, none of which needs a spreadsheet parser to render.
// Deferring it in the barrel means a caller cannot accidentally undo the split.
export const ImportDialog = defineAsyncComponent(
  () => import('./ui/components/ImportDialog.vue'),
);

// The root entity types a host can ask to import. Published because the host names one when it opens
// the dialog, and because it is the key the target implementations are registered under.
export { IMPORT_TYPES } from './domain/constants/importConsts';
